import type { ElementType } from 'react';

import { ReportTypeEnum } from '@/types/enums/report-type.enum';
import type { StatusTaskCheckEnum } from '@/types/enums/status-task-check.enum';
import { t } from '@/utils/lang';
import Chip from '@mui/material/Chip';

interface StatusChipProps {
    status: StatusTaskCheckEnum;
    size?: 'small' | 'medium';
    component?: ElementType;
    showChip?: boolean;
}

const ChipReportTypeStatus = ({
    status,
    size = 'medium',
    component: Component = Chip,
    showChip = true,
}: StatusChipProps) => {
    let label: string;
    let color: 'info' | 'warning' | 'success' | 'error' | 'default';

    const lowerCaseStatus = String(status || '')?.toLowerCase();

    switch (lowerCaseStatus) {
        case ReportTypeEnum.REPEAT_ERROR.toLowerCase():
        case 'repeat_error':
            label = 'Lỗi lặp lại';
            color = 'error';
            break;
        case ReportTypeEnum.ERROR_FREQUENCY.toLowerCase():
        case 'error_frequency':
            label = 'Tần suất lỗi';
            color = 'error';
            break;
        case ReportTypeEnum.PERFORMANCE.toLowerCase():
        case 'performance':
            label = 'Hiệu suất';
            color = 'error';
            break;
        default:
            label = 'Không xác định';
            color = 'default';
            break;
    }

    if (showChip) {
        return (
            <Component
                variant='tonal'
                label={t(label, 'ReportType')}
                color={color}
                size={size}
            />
        );
    }

    return {
        label: t(label, 'ReportType'),
        color,
    };
};

export default ChipReportTypeStatus;
